import React from 'react';
import styled from 'styled-components';
import {Icon} from '../Icon/Icon';

export const NotificationContainer = styled.div`
    display: flex;
    padding: 6px 20px;
    align-items: center;
    border-radius: 3px;
    p {
        padding: 0 4px;
        margin: 0;
    }
    ${({color}) => `
        border: 1px solid var(--${color});
        color: var(--${color});
        background: var(--${color}-notification);
    `}
`;

export const Notification = ({children, icon, color}) => (
    <NotificationContainer color={color}>
        {icon && <Icon name={icon} />}
        <p>{children}</p>
    </NotificationContainer>
);
